export const appRoutes = {
  main: '/search',
  login: '/login',
  register: '/register',
  home: '/',
  legacyHome: '/home',
  profile: '/profile',
  propertyWizard: '/property-wizard',
  agents: '/agents',
  listingProfile: '/listing/:id',
  propertyRequest: '/property-request',
  agentApplication: '/agent-application',
  developers: '/developers',
  developerRegister: '/developer-register',
  developerProjects: '/developer-projects',
  developerProfiles: '/developer-profiles',
  transactions: '/transactions',
  transactionDetail: '/transactions/:transactionId',
  gisPlatform: '/gis-platform'
};

export default appRoutes;
